import React from 'react';
import { pageTitle } from '../PageTitle';
import BreadCrumb from '../BreadCrumb';
import HeaderOne from '../Header/HeaderTwo';
import FooterOne from '../Footer/FooterTwo';
import { Link } from 'react-router-dom';

import partner1 from "../../assets/images/resource/partner-01.png";
import partner2 from "../../assets/images/resource/partner-02.png";
import partner3 from "../../assets/images/resource/partner-03.png";
import partner4 from "../../assets/images/resource/partner-04.png";
import partner5 from "../../assets/images/resource/partner-05.png";
import partner6 from "../../assets/images/resource/partner-06.png";
import partner7 from "../../assets/images/resource/partner-07.png";
import partner8 from "../../assets/images/resource/partner-08.png";
import partner9 from "../../assets/images/resource/partner-09.png";
import partner10 from "../../assets/images/resource/partner-10.png";
import partnerMit from "../../assets/images/resource/partner-mit.png";
import partnerNcsu from "../../assets/images/resource/partner-ncsu.png";
import partnerGmu from "../../assets/images/resource/partner-gmu.png";
import partnerVt from "../../assets/images/resource/partner-vt.png";
import partnerUt from "../../assets/images/resource/partner-ut.png";
import partnerUsf from "../../assets/images/resource/partner-usf.png";
import partnerLanl from "../../assets/images/resource/partner-lanl.png";
import partnerScale from "../../assets/images/resource/partner-scale.png";
import partnerBidwell from "../../assets/images/resource/partner-bidwell.png";
import partnerUcf from "../../assets/images/resource/partner-ucf.png";
import partnerUpenn from "../../assets/images/resource/partner-upenn.png";
import partnerNd from "../../assets/images/resource/partner-nd.png";
import partnerOsu from "../../assets/images/resource/partner-osu.png";
import partnerTufts from "../../assets/images/resource/partner-tufts.png";

const Partners = () => {
    pageTitle('Partners');

    const government = [
        { name: 'Defense Health Agency' },
        { name: 'Defense Threat Reduction Agency' },
        { name: 'Los Alamos National Laboratory', link: 'https://www.lanl.gov/', image: partnerLanl },
        { name: 'Missile Defense Agency' },
        { name: "SBA's Mason SBDC", link: 'https://masonsbdc.org/' },
        { name: 'US Air Force' },
        { name: 'US Army' },
        { name: 'Virginia Apex Accelerator', link: 'https://virginiaapex.org/' },
    ];

    const industry = [
        { name: 'BBC Entrepreneurial Training and Consulting, LLC', image: partner6, link: 'https://bbcetc.com/' },
        { name: 'Bidwell Solutions', image: partnerBidwell, link: 'https://www.bidwellnow.com/', dark: true },
        { name: 'Databasable', image: partner7, link: 'https://databasable.com/' },
        { name: 'Enclavix, LLC', image: partner8, link: 'https://enclavix.com/' },
        { name: 'Kitware', image: partner1, link: 'https://www.kitware.com/' },
        { name: 'Northwest Engineering Solutions', image: partner10, link: 'https://www.nwengineeringllc.com/' },
        { name: 'NS Nanotech, LLC', image: partner3, link: 'https://www.nsnanotech.com/' },
        { name: 'Ozen Engineering', image: partner9, link: 'https://www.ozeninc.com/' },
        { name: 'ReliAscent', image: partner4, link: 'https://www.reliascent.com/dcaa-compliant-accounting-systems' },
        { name: 'Scale LLP', image: partnerScale, link: 'https://scalefirm.com/' },
        { name: 'Synthetic Applied Technologies, LLC', image: partner2, link: 'https://www.synthetik-technologies.com/' },
        { name: 'TechOpp Consulting', image: partner5, link: 'https://techopp.com/' },
    ];

    const academia = [
        { name: 'George Mason University', image: partnerGmu, link: 'https://www.gmu.edu/' },
        { name: 'Massachusetts Institute of Technology', image: partnerMit, link: 'https://www.mit.edu/' },
        { name: 'North Carolina State University', image: partnerNcsu, link: 'https://www.ncsu.edu/' },
        { name: 'Oklahoma State University', image: partnerOsu, link: 'https://www.okstate.edu/' },
        { name: 'Tufts University', image: partnerTufts, link: 'https://www.tufts.edu/' },
        { name: 'University of Central Florida', image: partnerUcf, link: 'https://www.ucf.edu/' },
        { name: 'University of Notre Dame', image: partnerNd, link: 'https://www.nd.edu/' },
        { name: 'University of Pennsylvania', image: partnerUpenn, link: 'https://www.upenn.edu/' },
        { name: 'University of South Florida', image: partnerUsf, link: 'https://www.usf.edu/' },
        { name: 'University of Texas at Austin', image: partnerUt, link: 'https://www.utexas.edu/' },
        { name: 'Virginia Polytechnic Institute and State University', image: partnerVt, link: 'https://www.vt.edu/' },
    ];

    const renderLogoCard = (item) => {
        const image = (
            <div className={`partner__img${item.dark ? ' partner__img--dark' : ''}`}>
                <figure>
                    <img src={item.image} alt={item.name} />
                </figure>
            </div>
        );

        return (
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12" key={item.name}>
                <div className="partners-logo-card">
                    {item.link ? (
                        <a href={item.link} target="_blank" rel="noopener noreferrer" className="partners-card__link" title={item.name}>
                            {image}
                        </a>
                    ) : (
                        image
                    )}
                </div>
            </div>
        );
    };

    const renderGovCard = (item) => {
        const inner = (
            <div className="partners-gov-card">
                <span className="partners-gov-card__glow" aria-hidden="true" />
                <span className="partners-gov-card__label">Government Partner</span>
                <h3>{item.name}</h3>
            </div>
        );

        return (
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12" key={item.name}>
                {item.link ? (
                    <a href={item.link} target="_blank" rel="noopener noreferrer" className="partners-card__link" title={item.name}>
                        {item.image ? (
                            <div className="partners-logo-card">
                                <div className="partner__img">
                                    <figure>
                                        <img src={item.image} alt={item.name} />
                                    </figure>
                                </div>
                            </div>
                        ) : (
                            inner
                        )}
                    </a>
                ) : (
                    inner
                )}
            </div>
        );
    };

    return (
        <>
            <HeaderOne />
            <BreadCrumb title={"Partners & Customers"} />
            <div className="partners-page p_relative see__pad">
                <div className="partners-page__glow partners-page__glow--one" aria-hidden="true" />
                <div className="partners-page__glow partners-page__glow--two" aria-hidden="true" />

                <div className="auto-container">
                    <section className="partners-section" id="government">
                        <div className="partners-section__header">
                            <h2>Government</h2>
                            <p>Federal agencies, national laboratories, and public-sector partners</p>
                        </div>
                        <div className="row partners-grid">
                            {government.map(renderGovCard)}
                        </div>
                    </section>

                    <section className="partners-section" id="industry">
                        <div className="partners-section__header">
                            <h2>Industry</h2>
                            <p>Commercial technology, legal, and consulting partners</p>
                        </div>
                        <div className="row partners-grid">
                            {industry.map(renderLogoCard)}
                        </div>
                    </section>

                    <section className="partners-section" id="academia">
                        <div className="partners-section__header">
                            <h2>Academia</h2>
                            <p>Universities and research institutions</p>
                        </div>
                        <div className="row partners-grid">
                            {academia.map(renderLogoCard)}
                        </div>
                    </section>
                </div>
            </div>

            <section className="accomplised__section__two see__pad">
                <div className="auto-container">
                    <div className="accomplised__data two p_relative">
                        <div className="row">
                            <div className="col-lg-7 col-md-12">
                                <div className="title__data">
                                    <div className="sub__title">
                                        <h4>What we've accomplised</h4>
                                    </div>
                                    <div className="title">
                                        <h2>We pride ourselves on <br /> our excellent support <br /> and service</h2>
                                    </div>
                                </div>
                                <div className="btn-box">
                                    <Link to="/contact" className="theme-btn theme-btn-one"><i className="icon-02"></i> Contact Us</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <FooterOne />
        </>
    );
};

export default Partners;
